module.exports = __webpack_public_path__ + "img/partner.240617d3.png";